import { Article } from 'constants/blog';
import { BLOG_PAGE } from 'constants/pages';
import { ButtonLink } from 'components/Button';
import Post from 'components/blog/Post';
import SectionDivider from 'screens/ClubOverview/components/SectionDivider';

interface Props {
  posts: Article[];
}

// posts defaults to [] because ISR pages generated before this prop existed keep
// serving their old props until they revalidate.
export default function BlogSection({ posts = [] }: Props) {
  if (posts.length === 0) {
    return null;
  }

  return (
    <>
      <SectionDivider className="my-10" />
      <section className="flex flex-col gap-ds-xl">
        <div className="flex flex-col gap-ds-sm">
          <h2 className="typography-product-heading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            Blog
          </h2>
          <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            Explore what’s happening across the community — from player spotlights to upcoming
            tournaments and club updates.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((post) => (
            <Post
              key={post._id}
              id={post._id}
              slug={post.slug}
              title={post.title}
              image={post.mainImage}
              author={post.author}
              previewText={post.previewDescription}
              createdAt={post.publishedAt}
              tags={post.categories?.map(({ title }) => title) || []}
            />
          ))}
        </div>
        <div className="flex">
          <ButtonLink href={BLOG_PAGE} variant="secondary" size="md" isInline>
            View all posts
          </ButtonLink>
        </div>
      </section>
    </>
  );
}
